// extracted by mini-css-extract-plugin
export default {"link":"SetupAdminModal_link__MMBni","dropdownInput":"SetupAdminModal_dropdownInput__Km799"};